// Layout constants for architecture diagrams
export const ARCH_BLOCK_WIDTH = 160;
export const ARCH_BLOCK_HEIGHT = 72;
/** Minimum total node height before stacking a hero image above captions */
export const ARCH_BLOCK_HERO_IMAGE_MIN_HEIGHT = 100;
export const ARCH_GROUP_PADDING = 30;

export const ARCH_ASSET_CODE_WIDTH = 440;
export const ARCH_ASSET_CODE_HEIGHT = 240;
export const ARCH_ASSET_IMAGE_WIDTH = 300;
export const ARCH_ASSET_IMAGE_HEIGHT = 220;
